// extracted by mini-css-extract-plugin
var _1 = "768px";
var _2 = "NavigationFooter_navigationFooterContainer__4I0Nj";
var _3 = "NavigationFooter_nextButton__wNrKB";
var _4 = "NavigationFooter_questionMargins__k2nNo";
var _5 = "'../../shared.module.css'";
export { _1 as "md", _2 as "navigationFooterContainer", _3 as "nextButton", _4 as "questionMargins", _5 as "shared" }
